// extracted by mini-css-extract-plugin
export default {"grid":"Error_grid__tuNIt","heading":"Error_heading__KkSzt","subtext":"Error_subtext__iOsjJ","button":"Error_button__zny0G","active":"Error_active__VKs3I"};